import { Record } from 'immutable'

export const User = Record({
  id: null,
  name: null,
  locality: null,
  administrativeArea: null,
  highlightedPhotoId: 0
})

export const deserializeUser = (fromRails) => {
  const {
    highlighted_photo_id: highlightedPhotoId,
    administrative_area: administrativeArea,
    ...props
  } = fromRails

  return User({
    highlightedPhotoId,
    administrativeArea,
    ...props
  })
}
